import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel", "arrow"]
  static values = { open: { type: Boolean, default: true } }

  toggle() {
    this.openValue = !this.openValue
  }

  openValueChanged() {
    this.panelTarget.hidden = !this.openValue
    this.arrowTarget.classList.toggle("rotate-180", this.openValue)
  }
}
